import { render } from "./App.vue?vue&type=template&id=0b8271d9"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/27e3e97d/1/puttview/puttview-typo3/project/packages/pgw_golf_configurator/Resources/Public/Configurator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__